import { reqConfimOrder, reqGenOrder, reqVipCouponList } from '../../../api';
import { getUrlParams, toNumber } from '../../../utils';
import Toast from 'vant/es/toast';
import { reqGetAppid, reqPayTypeList } from '../../../api/api_base';
// import { nativeGet } from '../../../api/http';
import { mapGetters } from 'vuex';
import WX from 'weixin-js-sdk'

export default {
	data() {
		return {
			vipCardList: [], 	// vip套餐列表
			currentVipIndex: 0, // 当前选中套餐index
			currentVipObj: [],  // 当前选中vip套餐
			canCouponList: [],  // 可用优惠券列表
			disCouponList: [],  // 不可用优惠券列表
			showCouponModal: false, // 显示选择优惠券
			couponName: 'enableCoupon',
			couponAmount: 0, // 抵扣券金额
			couponAmountText: '',
			amount: '', // 实际支付金额
			payTypeList: [],
			payTypeObj: {
				200: '微信APP原生支付',
				201: '微信老板云原生',
				// 202: '微信扫码',
				211: '微信H5支付',
				212: '微信公众号支付',
				300: '支付宝APP原生支付',
				301: '支付宝老板云原生',
				// 202: '微信老板云原生',
				311: '支付宝H5支付',
        214: '老板云小程序支付'
			},
			currentPayObj: {},
			payType: null, // 支付方式
			payTypeId: null,
			disableBtn: false, // 支付按钮是否点击
			couponId: null, // 使用的优惠券id
			isWx: false, // 是否在微信环境下
			orderId: null, // 订单id
			requestOrderId: null, // 支付单id
			payUrl: '',
			payFail: false,
      payTipShow: false
		}
	},
	mounted() {
		this.originVip  = this.vipLevel // 开通前是否是会员
	},
	computed: {
		...mapGetters(['vipLevel']),
		// 可用优惠券张数
		canCouponNum: {
			get () {
				return this.canCouponList.length || 0
			},
			set () {
			}
		},
		// 不可用优惠券张数
		disCouponNum: {
			get () {
				return this.disCouponList.length || 0
			},
			set () {
			}
		},
		// couponAmountText: {
		// 	get() {
		// 		return `- ${this.couponAmount}`
		// 	},
		// 	set () {
		// 	}
		// },
		couponNumber: {
			get() {
				return this.canCouponNum + this.disCouponNum
			},
			set () {
			}
		}
	},
	methods: {
		// 获取支付方式
		getPayTypeList() {
      let ua = navigator.userAgent.toLowerCase();
      let loginSource = (ua.match(/MicroMessenger/i) == "micromessenger") && (localStorage.getItem('s') == 'H5' || '') ? 'H5-WECHAT' : localStorage.getItem('s')
			let params = {
				loginSource
			}
			reqPayTypeList(params).then((res)=>{
				this.payTypeList = res.data
				if(this.payTypeList.length){
					this.choosePayType(this.payTypeList[0])
				}
			})
		},
		// 获取优惠券列表
		getChooseCouponList() {
			let params = {
				orderAmount: this.currentVipObj.price
			}
			reqVipCouponList(params).then(res =>{
				this.canCouponList = res.data.availableList
				this.disCouponList = res.data.notAvailableList
			})
		},
		// 选择优惠券\获取优惠券
		chooseCoupon(){
			this.showCouponModal = true
		},
		// 使用优惠券
		useCoupon(couponObj){
			// 请求使用优惠券之后的实际支付金额
			this.couponId = couponObj.id
			// 优惠券点击埋点
			// eslint-disable-next-line
			sensors.track('coupon_id', {
				coupon_id: this.couponId
			})
			this.getAmount()
		},
		// 请求实际金额
		getAmount(){
			let params  = {
				couponId: this.couponId,
				vipLevelId: this.currentVipObj.id
			}
			reqConfimOrder(params).then(res=>{
				let resData = res.data
				let actualAmountText = resData.actualAmountStr
				this.amount =  actualAmountText
				this.couponAmount = toNumber(resData.couponDiscountAmount)
				this.couponAmountText = `-${this.couponAmount}`
				this.$forceUpdate()
				this.showCouponModal = false
			})
		},
		// 选择支付方式
		choosePayType(item) {
			this.currentPayObj = item
			this.payType = item.payType
			this.payTypeId = item.payTypeId
		},
		// 页面跳转
		goPath(path){
			if(path==='/vip/vipfree'){
				// eslint-disable-next-line
				sensors.track('giveAwayVipClick', {
					page_positon: '我的'
				})
			}
			this.$router.push({
				path
			})
		},
		// wxPay
		async getWxPayCode(){
			//  获取code
			let code = getUrlParams("code"); //是否存在code
			if (code == null || code === "") {
				let resData = await this.getWxAppId();
				let appid  = resData.data
				//不存在就打开上面的地址进行授权
				let local = window.location.href.indexOf('?')> -1 ? window.location.href+`&payUrl=${this.payUrl}` : window.location.href+`?payUrl=${this.payUrl}`
				window.location.href =
					`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${ appid }&redirect_uri=${ encodeURIComponent(local) }&response_type=code&scope=snsapi_base&state=1#wechat_redirect&connect_redirect=1`;
			}
		},
		// 去支付
		async goPay() {
			// 校验手机号是否为空
      if(!this.friendPhone&& this.pageName === 'freevip'){
				Toast('请输入赠送好友手机号')
				return
			}
      // 环境判断
      let ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) !="micromessenger"){
        let s = localStorage.getItem('s')
        let loginChannel =  localStorage.getItem('loginChannel')
        if((s == 'BS' && loginChannel == '124') || s == 'H5' || !s){  // M站环境和普通浏览器环境
          this.payTipShow = true
          return
        }
      }
			// 数据埋点
			this.payTrack()
			if(this.disableBtn){
				return
			}
			this.disableBtn = true
			setTimeout(()=>{
				this.disableBtn = false
			}, 3000)
      if(!this.payTypeId){
        Toast("请选择支付方式")
        return
      }
			//  生成订单
			let res = await this.generateOrder()
      console.log('res',res)
			if(!res) {
				return
			}
			this.orderId = res.orderId // 生成的订单号
			// 调起支付
			switch (Number(this.payTypeId)) {
				case 212:  // 公众号支付
					if(res.payInput){
						this.payUrl = res.payInput.payUrl
						this.getWxPayCode()
					}
					break;
				case 201:  // 老板云微信支付
					if(res.payInput && res.payInput.wechatAppData){
						this.handleAppWxPay(res.payInput.wechatAppData)
					}
					break;
				case 301:  // 老板云支付宝支付
					if(res.payInput && res.payInput.tojoyAliData){
						this.handleAppAlipay(res.payInput.tojoyAliData)
					}
					break;
        case 214: // 跳老板云小程序支付-只会在安卓环境内出现
        if(res.payInput && res.payInput.wechatMiniData){
          let data = {
            path: res.payInput.wechatMiniData.path, // path
            originalPrice: this.currentVipObj.originalPrice, // 原价
            price: this.amount, // 支付价格
            name: this.currentVipObj.name, // 卡名称
            orderId: this.orderId,
            source: this.pageName === 'freevip' ? 'freevip' : 'buyvip'
          }
          WX.miniProgram.navigateTo({
            url: `/pages/policySubsidyPay/index?data=${encodeURIComponent(JSON.stringify(data))}`
          })
        }
          break
				default:
			}
		},
		// 生成订单
		generateOrder() {
			let params = {
				couponId: this.couponId, // 优惠券id
				payType: this.payTypeId,  // 支付方式 TODO
				vipLevelId: this.currentVipObj.id,
				consigneeMobile: this.friendPhone // 赠送好友手机号
			}
			return reqGenOrder(params).then((res) => {
				if(res.ok){
					return res.data
				} else {
					Toast(res.msg)
					if(res.code === '271002' || res.code === '271010'){
						setTimeout(()=>{
							this.getVipList()
						},2000)
					}else if(res.code === '271003' || res.code === '271004' || res.code === '271005' || res.code === '271006'){
						this.resetCouponData()
					}
				}
				this.disableBtn =  false
			})
		},
		// 重置优惠券相关数据
		resetCouponData(){
			this.couponId = null
			this.couponAmount =  0
			this.couponAmountText = ''
			this.amount = this.currentVipObj.price
			this.getChooseCouponList()
		},
		// 跳转成功/失败页面
		goTipsPage (path, data) {
			this.$router.push({
				path,
				query: data || {}
			})
		},
		// h5支付：获取appid
		getWxAppId() {
			return reqGetAppid()
		},
		// h5调起原生微信支付
		handleAppWxPay(res){
			// 获取支付参数
			let params = {
				partnerId: res.partnerid, // 商家向财付通申请的商家id
				prepayId: res.prepayid, // 预支付id
				nonceString:  res.noncestr,  // 随机串
				timeStamp: res.timestamp,  // 时间戳
				packageValue:  res.packageStr, // 商家根据财付通文档填写的数据和签名
				signCode: res.sign  // 商家根据微信开放平台文档对数据做的签名
			}
			this.$bridge.callhandler('requestPay',params).then((result) =>{
				if(Number(result) && Number(result) === 1){
					// 成功回调页面
					let data = {
						orderId: this.orderId
					}
					if(this.pageName === 'freevip'){
						this.goTipsPage('/vip/successfreevip',data)
					} else if(this.pageName ==='joinvip'){
						data.originVip= this.originVip
						this.goTipsPage('/vip/successjoinvip',data)
					}
				}else{
					// Toast('支付已取消，请重新下单');
					this.resetCouponData()
				}
			}).catch(err => console.log('回调error',err))
		},
		// 调起微信支付
		initBridge (resp) {
			if (!window.WeixinJSBridge) {
				if (document.addEventListener) {
					document.addEventListener('WeixinJSBridgeReady', () => this.onBridgeReady(resp), false);
				} else if (document.attachEvent) {
					document.attachEvent('WeixinJSBridgeReady', () => this.onBridgeReady(resp));
					document.attachEvent('onWeixinJSBridgeReady', () => this.onBridgeReady(resp));
				}
			} else {
				this.onBridgeReady(resp);
			}
		},
		// 调起微信支付
		onBridgeReady (res) {
			let resp = JSON.parse(res)
			const params = {
				appId: resp.appId,          // 公众号名称，由商户传入
				timeStamp: resp.timeStamp,  // 时间戳，自1970年以来的秒数
				nonceStr: resp.nonceStr,    // 随机串
				package: resp.package,
				signType: 'MD5',            // 微信签名方式
				paySign: resp.paySign       // 微信签名
			};
			window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, res => {
					if (res.err_msg === 'get_brand_wcpay_request:ok') { // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
						// 成功回调页面
						let data = {
							requestOrderId: this.requestOrderId
						}
						//  获取个人信息，更新缓存
						this.$store.dispatch('getMyPageInfo',{router:this.router});
						if(this.pageName === 'freevip'){
							this.goTipsPage('/vip/successfreevip',data)
						} else if(this.pageName ==='joinvip'){
							data.originVip= this.originVip
							this.goTipsPage('/vip/successjoinvip',data)
						}
					} else {
						Toast('因为您中途取消支付，订单信息已失效，页面即将刷新');
						setTimeout(()=>{
							this.$router.history.go(-1)
						},2000)
						// this.payFail = true
					}
				}
			);
		},
		// 调起app支付宝支付
		handleAppAlipay(dataStr){
			// let tradeNo = dataStr.tradeNo
			let form = dataStr.form
			let params = {
				orderStr: form
			}
			this.$bridge.callhandler('requestAliPay',params).then((result) =>{
				if(typeof result === 'string') {
					result = JSON.parse(result)
				}
				if(result.resultStatus === '9000' || result.resultStatus === 9000){
					// 成功回调页面
					let data = {
						orderId: this.orderId
					}
					if(this.pageName === 'freevip'){
						this.goTipsPage('/vip/successfreevip',data)
					} else if(this.pageName ==='joinvip'){
						data.originVip= this.originVip
						this.goTipsPage('/vip/successjoinvip',data)
					}
				} else {
					Toast('支付已取消，请重新下单');
					this.resetCouponData()
				}
			}).catch(err => console.log(err))
			// this.$bridge.registerhandler('onPayFail').then((resultData, callBack) =>{
			// 	alert('监听成功'+resultData)
			// 	callBack && callBack()
			// })
		},
		// 调起支付埋点
		payTrack(){
			let pay_type = ''
			if(this.pageName === 'joinvip'){
				pay_type = Number(localStorage.getItem('vipLevel')) ? '续费' : '开通会员'
			}else {
				pay_type = '赠送好友'
			}
			// eslint-disable-next-line
			sensors.track('paymentClick', {
				pre_page: this.pageName === 'joinvip'? '/vip/vipjoin' : '/vip/vipfree',
				pay_type: pay_type,
				friend_phone: this.friendPhone || '',
				pay_way: this.currentPayObj.payTypeName,
				vip_time: this.currentVipObj.timeLenStr,
				vip_price: toNumber(this.currentVipObj.originalPrice),
				vip_discount: toNumber(this.currentVipObj.price),
				vip_payment: this.amount ? toNumber(this.amount) : 0,
				is_coupon: this.couponId ? true : false,
				coupon_id: this.couponId ? this.couponId : '',
				coupon_amount: this.couponAmount || 0

			});
		}
		// 支付结果埋点
		// payResultTrack(isSuccess, failReason){
		// 	let pay_type = ''
		// 	if(this.pageName === 'joinvip'){
		// 		pay_type = Number(localStorage.getItem('vipLevel')) ? '续费' : '开通会员'
		// 	}else {
		// 		pay_type = '赠送好友'
		// 	}
		// 	// eslint-disable-next-line
		// 	sensors.track('paymentResult', {
		// 		is_success: isSuccess,
		// 		fail_reason: !isSuccess&&failReason ? failReason : '',
		// 		pay_type: pay_type,
		// 		friend_phone: this.friendPhone || '',
		// 		pay_way: this.currentPayObj.payTypeName,
		// 		vip_time: this.currentVipObj.name,
		// 		vip_price: toNumber(this.currentVipObj.originalPrice),
		// 		vip_discount: toNumber(this.currentVipObj.price),
		// 		vip_payment: this.amount ? toNumber(this.amount) : 0,
		// 		is_coupon: this.couponId ? true : false,
		// 		coupon_id: this.couponId ? this.couponId : '',
		// 		coupon_amount: this.couponAmount || 0
		//
		// 	});
		// },
	}
}
